import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { featureFlagReducer } from '@surfline/web-common/dist/features';
import tiles from './charts/tiles';
import designIterations from './charts/designIterations';
import swell from './charts/swell';
import period from './charts/period';
import wind from './charts/wind';
import sst from './charts/sst';
import pressure from './charts/pressure';
import status from './status';
import cms from './cms';
import user from './user';
import map from './map';
import tides from './tides';
import forecast from './forecast';
import solunar from './solunar';

export default combineReducers({
  routing: routerReducer,
  status,
  forecast,
  tides,
  cms,
  user,
  map,
  solunar,
  charts: combineReducers({
    tiles,
    designIterations,
    swell,
    period,
    wind,
    sst,
    pressure,
  }),
  flags: featureFlagReducer,
});



// WEBPACK FOOTER //
// ./src/reducers/index.js